import React, { Component } from 'react';
import { PageHeader } from 'components/page-header';
import { Page } from 'components/page-container';
import { Filters } from 'modules/filters/containers/Filters';
import { FiltersInput } from 'modules/filters/components/FiltersInput';
import { IStore } from 'reducers/index';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { connect } from 'react-redux';
import { FiltersDateInput } from 'modules/filters/components/FiltersDateInput';
import { RouteComponentProps, withRouter } from 'react-router';
import {
    clearFilters,
    applyFiltersAction
} from 'actions/filters';
import { fetchEssoRates } from 'actions/extraDocument';
import { formatDate } from 'utilities/util';
interface IMapState {
    filters: any;
    issoRates: any;
}

interface IMapDispatch {
    fetchEssoRates: () => Promise<void>;
    clearFilters: () => void;
    applyFilters: () => void;
}

interface IEventLogsProps extends RouteComponentProps, IMapState, IMapDispatch { }

interface IEventLogsState {
    fetchInProgress: boolean;
    shuoldFetch: boolean,
    dateFrom: boolean,
    startDate: string;
    endDate: string;
    beCode: string;
}

export class _EssoMigrate extends Component<IEventLogsProps, IEventLogsState> {
    public ctx: any = null;
    public state = {
        fetchInProgress: false,
        shuoldFetch: false,
        dateFrom: false,
        startDate: '',
        endDate: '',
        beCode: ''
    };
    public componentDidMount() {
        this.props.clearFilters()
        this.ctx = document.getElementById('apply-filters-button');
        this.ctx.innerHTML = 'Download';
    }
    public componentDidUpdate(props: any, state: any) {
        if (this.props.filters.dateFrom !== props.filters.dateFrom || this.props.filters.dateTo !== props.filters.dateTo 
            || this.props.filters.customerBeCode !== props.filters.customerBeCode) {
                this.setState({
                    startDate: this.props.filters.dateFrom && formatDate(this.props.filters.dateFrom.toString(), 'YYYY-MM-DD'),
                    endDate: this.props.filters.dateTo && formatDate(this.props.filters.dateTo.toString(), 'YYYY-MM-DD'),
                    beCode: this.props.filters.customerBeCode
                })
        }
    }
    public checkNullValue = (code: any, startDate: any, endDate: any) => {
        if(code === '' || startDate === undefined || startDate === '' || startDate === null 
        || endDate === undefined || endDate === null || endDate === '') {
            return true;
        } else {
            return false;
        }
    }
 
    public componentWillUnmount() {
        this.props.clearFilters()
        this.setState({ dateFrom: false, shuoldFetch: false })
    }
    public render() {
        return (
            <React.Fragment>
                <PageHeader>Athena-FACT Rate comparison</PageHeader>
                <Page>
                    <div className={'padding-top-xLarge'}>
                        <Filters
                            tableNameKey="IssoRates"
                            fetchFunction={() => {
                                this.fetchEventsList()
                            }}
                            resetErrors={() => {
                                this.props.clearFilters()
                                this.setState({ dateFrom: false, shuoldFetch: true })
                            }}
                            disableSubmit={this.state.dateFrom || this.checkNullValue(this.state.beCode, this.state.startDate, this.state.endDate)}
                            filters={[
                                <FiltersInput
                                    name="customerBeCode"
                                    label="Customer BE Code"
                                    key="customerBeCode"
                                    readonly={false}
                                />,
                                <FiltersDateInput
                                    name="dateFrom"
                                    label="Date (from)"
                                    key="dateFrom"
                                    relatedField="dateTo"
                                    type="dateFromTo"
                                    setValidity={(val: any) => this.setState({ dateFrom: val })}
                                    isInvalid={this.state.dateFrom}
                                    withTime={false}
                                />,
                                <FiltersDateInput
                                    name="dateTo"
                                    label="Date (to)"
                                    key="dateto"
                                    type="dateFromTo"
                                    minValue="dateFrom"
                                    setValidity={(val: any) => this.setState({ dateFrom: val })}
                                    isInvalid={this.state.dateFrom}
                                    withTime={false}
                                />
                            ]}
                        />
                    </div>
                </Page>
            </React.Fragment>
        );
    }
    private fetchEventsList = async() => {
        if(!this.state.shuoldFetch){
            await this.props.fetchEssoRates()
            if(this.props.issoRates) {
                this.downLoadFile(this.props.issoRates)
            }
        }
    };
    private downLoadFile = (response: any) => {
        const filename = response.headers['content-disposition'].split(';')[1].split('filename="')[1].replace('"', '');
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
    };
}

const mapStateToProps = (state: IStore): IMapState => ({
    filters: state.filters.filters,
    issoRates: state.extraDocument.issorates
});

const mapDispatch = (dispatch: ThunkDispatch<any, any, Action>): IMapDispatch => ({
    fetchEssoRates: () => dispatch(fetchEssoRates()),
    clearFilters: () => dispatch(clearFilters()),
    applyFilters: () => dispatch(applyFiltersAction())
});

export const __EssoMigrate = connect<IMapState, IMapDispatch, {}, IStore>(mapStateToProps, mapDispatch)(_EssoMigrate);
export const Index = withRouter(__EssoMigrate)